import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import AppModal from "./Generic/AppModal/AppModal";
import Spinner from "./Generic/Spinner";

type Props = {
  isOpen: boolean;
};

export default function UploadingModal(props: Props) {
  return (
    <AppModal
      type="neutral"
      title={translate(STRINGS.UPLOADING)}
      message={translate(STRINGS.PLEASE_WAIT)}
      actions={[]}
      isOpen={props.isOpen}
    >
      <Spacer />
      <Spinner size={32} />
    </AppModal>
  );
}

const Spacer = styled.div`
  height: 16px;
`;
